import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  MoreActionsImage,
  MoreActionsImageWebp,
} from '../../../assets/images/imageRepository';

const useGetMoreActionsContent = () => {
  const moreActionImages = MoreActionsImage;
  const moreActionImagesWebp = MoreActionsImageWebp;
  const MoreActionsContent = [
    {
      key: 'templates',
      image: moreActionImages.templates.image,
      imageWebp: moreActionImagesWebp.templates.image,
      description: (
        <FormattedMessage
          id="landing.instagram.moreactions.action1.description"
          defaultImage="Use + 3,000 templates or edit your own content"
        />
      ),
    },
    {
      key: 'publishVideos',
      image: moreActionImages.publishVideos.image,
      imageWebp: moreActionImagesWebp.publishVideos.image,
      description: (
        <FormattedMessage
          id="landing.instagram.moreactions.action2.description"
          defaultImage="Post videos or images optimized for all your business networks"
        />
      ),
    },
    {
      key: 'recommendations',
      image: moreActionImages.recommendations.image,
      imageWebp: moreActionImagesWebp.recommendations.image,
      description: (
        <FormattedMessage
          id="landing.instagram.moreactions.action3.description"
          defaultImage="Know the best time to post for your business"
        />
      ),
    },
    {
      key: 'messages',
      image: moreActionImages.messages.image,
      imageWebp: moreActionImagesWebp.messages.image,
      description: (
        <FormattedMessage
          id="landing.instagram.moreactions.action4.description"
          defaultImage="Answer all your messages or comments in one place"
        />
      ),
    },
  ];

  return MoreActionsContent;
};

export default useGetMoreActionsContent;
